module.exports = __webpack_public_path__ + "static/media/android.4714a65d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/android.jpg
// module id = 98
// module chunks = 0